






























































import { BrcodeType, ContractReasonCancellation } from '@/app/shared/enums';
import { InteractionModel, VForm } from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
@Component
export default class DialogCancelContractComponent extends Vue {
  @Ref() private form!: VForm;

  private dialog = false;
  private valueTab = '';
  private loading = false;
  private refundPaymentMethod = 0;
  private pixMethod: BrcodeType = 0;
  private reason: ContractReasonCancellation = 0;

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
  private async cancelContract() {
    if (this.form && this.form.validate())
      if (this.refs.modules.data.isBilling) {
        this.refs.modules.contract
          .cancelContract({
            contractId: this.refs.modules.contract.contract.Id,
            ReasonForCancellation: this.reason,
            descReason: this.reason + ' - ' + this.valueTab,
          })
          .then(() => {
            this.$toast(this.$t('toasts.contract_cancel_successfully'));

            localStorage.removeItem('tabulacao');
            this.$bus.$emit('cleanValueTab');

            this.refs.modules.contract.loadContractById(
              this.refs.modules.contract.contract.Id
            );
            this.dialog = false;
          })
          .catch((err) => {
            this.$toast.error('ERROR ? ', err);
            this.$toast.error(this.$t('toasts.contract_cancel_error'));
          });
      } else {
        const policy = this.refs._.clone(this.refs.modules.policy.policy);
        policy.Status = this.refs.enums.PolicyStatus.Canceled;
        this.refs.modules.policy
          .updatePolicy({ policyId: policy.Id, policy })
          .then(() => {
            this.$toast(this.$t('toasts.contract_cancel_successfully'));
            this.refs.modules.ticket.createInteraction(
              new InteractionModel(
                this.$t('action_code.ac4'),
                this.reason + ' - ' + this.valueTab
              )
            );
            this.refs.modules.policy.loadPolicyById(policy.Id);
            this.dialog = false;
          })
          .catch((err) => {
            this.$toast.error('ERROR ? ', err);
            this.$toast.error(this.$t('toasts.contract_cancel_error'));
          });
      }
  }

  @Watch('dialog')
  private onChangeDialog(value: boolean): void {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
    if (value && this.form) this.form.resetValidation();
  }
}
